module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj4KICA8cGF0aAogICAgICBmaWxsPSIjRDkzMDIzIgogICAgICBkPSJNMjAwLjggMTU3LjJsLTM2LjQgMzcuNEw0MTEuNyA0NDhsMzYuMy0zNy40ek0xODEgNjRoMzd2NjhoLTM3ek0xODEgMjYyaDM3djY4aC0zN3pNMjcwIDE3Nmg2OXYzN2gtNjl6TTMwNS42IDExNS44bC0yNS43LTI2LjMtNDcuMSA0OC4zIDI1LjYgMjYuMnpNMTY4LjggMTM3LjhsLTQ3LjEtNDguMy0yNS42IDI2LjMgNDcuMSA0OC4yek05Ni4xIDI3Ny45bDI1LjYgMjYuMiA0Ny4xLTQ4LjItMjUuNi0yNi4zek02NCAxNzZoNjV2MzdINjR6Ii8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/cases/dms/img/md-color-wand.svg
// module id = 724
// module chunks = 267937933260274